/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem,
    DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSON,
    DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


